import type { ReactNode } from 'react';

export const symbol_tools_phillips: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M310-120q-13 0-21.5-8.5T280-150q0-13 8.5-21.5T310-180h340q13 0 21.5 8.5T680-150q0 13-8.5 21.5T650-120H310Zm0-120q-13 0-21.5-8.5T280-270v-350q0-10 3-19t9-17l126-168q6-8 14-12t18-4h60q10 0 18 4t14 12l126 168q6 8 9 17t3 19v350q0 13-8.5 21.5T650-240H310Zm30-60h280v-111L480-551 340-411v111Zm0-196 110-110v-161L340-620v124Zm280 0v-124L510-767v161l110 110Zm0 196H340h280Z"
		/>
	</svg>
);
